import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "common-container"
};
import { ref } from 'vue';
import Header from './Header'; // 组件-头部
import Footer from './Footer'; // 组件-尾部
import PhoneHeader from '@/components/PhoneComponents/Common/PhoneHeader'; // 组件-移动端-头部
import PhoneFooter from '@/components/PhoneComponents/Common/PhoneFooter'; // 组件-移动端-尾部
/**
 * 1.请求公司基本信息
 * 2.请求站点信息
 */
import { getCompanyInfo, getSiteInfo } from '@/api/common';
export default {
  __name: 'index',
  setup(__props) {
    const data = ref({});
    // 函数-请求公司基本信息
    const __getCompanyInfo = async () => {
      const {
        data: res
      } = await getCompanyInfo();
      if (res.result !== 0) return;
      data.value.name = res.data.name;
      data.value.email = res.data.email;
      data.value.address = res.data.address;
      data.value.weixin = res.data.weixin;
    };
    // 函数-请求站点信息
    const __getSiteInfo = async () => {
      const {
        data: res
      } = await getSiteInfo();
      if (res.result !== 0) return;
      data.value.domain = res.data.domain;
      data.value.icp = res.data.icp;
      data.value.copyright = res.data.copyright;
      data.value.logo = res.data.logo;
    };
    __getCompanyInfo();
    __getSiteInfo();
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(Header), {
        class: "PC-header",
        logo: data.value.logo
      }, null, 8, ["logo"]), _createVNode(_unref(PhoneHeader), {
        class: "phone-header",
        logo: data.value.logo
      }, null, 8, ["logo"]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "phone-header-transition",
        style: {
          "height": "1.5rem"
        }
      }, null, -1)), _createVNode(_component_router_view), _createVNode(_unref(Footer), {
        class: "PC-footer",
        baseInfo: data.value
      }, null, 8, ["baseInfo"]), _createVNode(_unref(PhoneFooter), {
        class: "phone-footer",
        baseInfo: data.value
      }, null, 8, ["baseInfo"])]);
    };
  }
};